var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"contractors-table",attrs:{"title":_vm.title,"url":"/contractors","fields":_vm.fields,"table-ref":"contractors-table","detail-component":"contractor-detail-row"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }